import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBBtn,
  MDBInput,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCheckbox,
  MDBDatePicker,
  MDBCardText,
  MDBRipple,
} from "mdb-react-ui-kit";
import "../css/service.css";

const AboutAcerhealth = () => {
  return (
    <MDBContainer fluid className="p-0 bg-light">
      <div className="container py-5">
        <h2 className="AcerhealthTextPurple text-center testourvalue" style={{fontFamily:'Lora, serif', fontWeight: 'bold' }}>
          Our Values
        </h2>
        <br></br>
        <MDBRow className="justify-content-center">
          <MDBCol md="6" lg="3">
            <div className="card rounded service-wrapper rounded border-0 shadow p-4" style={{ width: '335px', height: '300px' }}>
              <h3 class="text-center AcerhealthTextPurple testourvalues1" style={{fontFamily: "Alegreya Sans", fontWeight: 'bold' }}>Diversity</h3>
              <p className="justify-content-left" style={{ height: '150px', fontSize: '18px', fontFamily: "Alegreya Sans",fontWeight:'500' }}>
              We deliver inclusive medical billing services by collaborating with diverse healthcare experts, ensuring tailored revenue cycle management solutions for every practice’s unique needs.
              </p>
            </div>
          </MDBCol>

          <MDBCol md="6" lg="3">
            <div className="card rounded service-wrapper rounded border-0 shadow p-4" style={{ width: '335px', height: '300px' }}>
              <h3 class="text-center AcerhealthTextPurple testourvalues1" style={{fontFamily: "Alegreya Sans", fontWeight: 'bold' }}>Expertise</h3>
              <p className="justify-content-left" style={{ height: '150px', fontSize: '18px', fontFamily: "Alegreya Sans",fontWeight:'500' }}>
                Leveraging deep industry knowledge and cutting-edge research, we lead in medical billing services and revenue cycle management, continuously adapting to healthcare changes.
              </p>
            </div>
          </MDBCol>

          <MDBCol md="6" lg="3">
            <div className="card rounded service-wrapper rounded border-0 shadow p-4" style={{ width: '335px', height: '300px' }}>
              <h3 class="text-center AcerhealthTextPurple testourvalues1" style={{fontFamily: "Alegreya Sans", fontWeight: 'bold' }}>Technology</h3>
              <p className="justify-content-left" style={{ height: '150px', fontSize: '18px', fontFamily: "Alegreya Sans",fontWeight:'500' }}>
              We leverage advanced EMR billing integration and software solutions to streamline patient payments, reduce costs, accelerate statements, and ensure secure medical billing transactions.            </p>
            </div>
          </MDBCol>

          <MDBCol md="6" lg="3">
            <div className="card rounded service-wrapper rounded border-0 shadow p-4" style={{ width: '335px', height: '300px' }}>
              <h3 class="text-center AcerhealthTextPurple testourvalues1" style={{fontFamily: "Alegreya Sans", fontWeight: 'bold' }}>Client Satisfaction</h3>
              <p className="justify-content-left" style={{ height: '150px', fontSize: '18px', fontFamily: "Alegreya Sans",fontWeight:'500' }}>
               AcerHealth delivers personalized medical billing services using modern technology and expert support to exceed expectations and build lasting healthcare partnerships.            </p>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </MDBContainer>
  );
};

export default AboutAcerhealth;
